import { OTP_STATE } from "app/components/verify-otp/otp-state"

export class PHONE_STATE extends OTP_STATE {
  public static readonly SET_PHONE = 'set_phone';
}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-phone/phone-state.ts